import { Box, BoxProps, Flex, FlexProps, Icon, IconProps, Text } from '@chakra-ui/react';
import Image from 'next/image';
import { FC, memo } from 'react';
import { FaUserCircle } from 'react-icons/fa';
import useColorValue from 'src/hooks/useColorValue';
// import colors from 'src/theme/colors';

const sizes = {
  '2xs': 20,
  'xs': 24,
  'sm': 32,
  'md': 48,
  'lg': 64,
  'xl': 96,
  '2xl': 128,
}

const pluckSize = size => sizes[size]

/**
 * this is wack but we'll see what happens with open source
 * as next/image develops
 * https://github.com/47ng/chakra-next/blob/v3/src/components/image.tsx
 */
const Avatar: FC<AvatarProps> = ({ size, src = null, name = null, alt = 'avatar image', ...rest }) => {
  const diameter = `${pluckSize(size)}px`
  const accent5 = useColorValue('accent5')
  const accent2 = useColorValue('accent2')

  if (!src) {
    if (name) {
      const initials = name.trim().split(' ').map(word => word[0]?.toUpperCase() || word).slice(0, 2).join(' ')

      return (
        <Flex
          {...rest}
          w={diameter}
          h={diameter}
          flexBasis={diameter}
          flexGrow={0}
          flexShrink={0}
          borderRadius='99px'
          justify='center'
          align='center'
          borderColor={accent2}
          borderWidth='1px'
        >
          <Text
            fontWeight='600'
            color={accent5}
            fontSize={`${pluckSize(size) / 4}px`}
            lineHeight={`${pluckSize(size) / 4}px`}
          >
            {initials}
          </Text>
        </Flex>
      )
    }

    return (
      <Icon
        {...rest}
        w={diameter}
        h={diameter}
        as={FaUserCircle}
        color={accent2}
      />
    )
  }

  // const outline = Math.max(0.5, sizes[size] / 48)

  return (
    <Box
      w={diameter}
      h={diameter}
      flexBasis={diameter}
      // boxShadow={`0 0 0 ${outline}px ${colors.primary.background}, 0 0 0 ${outline * 2}px ${colors.primary.accent5}`} // not so sure about this
      className='pl-avatar' // this is bad, temporary while next/image develops
      borderRadius='99px'
      {...rest}
    >
      <Image
        src={src}
        alt={alt}
        key={src}
        width={diameter}
        height={diameter}
        objectFit='cover'
        layout='fixed'
      />
    </Box>
  )
}

type AvatarProps = {
  size: keyof typeof sizes,
  alt?: string,
  src?: string,
} & Omit<BoxProps, 'width' | 'height'>
  & Omit<IconProps, 'width' | 'height'>
  & Omit<FlexProps, 'width' | 'height'>

export default memo(Avatar)
